import React from 'react'

import { object, string, bool, arrayOf, shape } from 'prop-types'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import Hamburger from './Components/Hamburger/Hamburger'
import Logo from './Components/Logo/Logo'
import Menu from './Components/Menu/Menu'
import Search from './Components/Search/Search'
import UserActions from './Components/UserActions/UserActions'
import { useHamburgerStatus } from './Hooks/useHamburgerStatus'

function Navigation({
  commonRoutes,
  mainMenuItems = EMPTY_OBJECT,
  communityLinks = EMPTY_ARRAY,
  createAiLinks = EMPTY_ARRAY,
  showFreeTrialTag = false,
  actionsLinks = EMPTY_ARRAY,
  actionsConfig = EMPTY_OBJECT,
  locale = 'en',
  isInListingPage = false,
  searchInputValue = '',
  searchPlaceholder,
}) {
  const { root } = commonRoutes
  const { isActive, toggle } = useHamburgerStatus()

  return (
    <div className="unified-nav">
      {isActive && (
        <button
          type="button"
          className="unified-nav__backdrop"
          onClick={toggle}
          aria-label="Close menu"
        />
      )}
      <Hamburger isActive={isActive} onToggle={toggle} />
      <Logo url={root} />
      <Search
        locale={locale}
        isInListingPage={isInListingPage}
        searchInputValue={searchInputValue}
        searchPlaceholder={searchPlaceholder}
      />
      <Menu
        isActive={isActive}
        mainMenuItems={mainMenuItems}
        communityLinks={communityLinks}
        createAiLinks={createAiLinks}
        showFreeTrialTag={showFreeTrialTag}
        locale={locale}
      />
      <UserActions
        actionsLinks={actionsLinks}
        actionsConfig={actionsConfig}
        locale={locale}
      />
    </div>
  )
}

Navigation.propTypes = {
  commonRoutes: object.isRequired,
  mainMenuItems: object,
  communityLinks: arrayOf(shape({
    href: string,
    trackText: string,
    title: string,
    icon: string,
  })),
  createAiLinks: arrayOf(shape({
    id: string,
    href: string,
    title: string,
    trackText: string,
    icon: string,
    tag: string,
  })),
  showFreeTrialTag: bool,
  actionsLinks: arrayOf(shape({
    id: string,
    href: string,
    icon: string,
  })),
  actionsConfig: shape({
    isCurrentUser: bool,
    newRoyaltyUi: bool,
  }),
  locale: string,
  isInListingPage: bool,
  searchInputValue: string,
  searchPlaceholder: string.isRequired,
}

export default Navigation
